<template>
  <div class="space-x-1 leading-5 truncate">
    <input
      :id="id"
      :aria-checked="checked"
      :checked="checked"
      class="border text-blue disabled:opacity-30 text-base md:text-sm shadow-xs rounded-xs border-blue ring-inset focus:ring-0"
      :class="{
        'cursor-wait': loading,
        'cursor-not-allowed': disabled,
        'cursor-pointer': !disabled && !loading,
      }"
      :disabled="disabled || loading"
      type="checkbox"
      :value="modelValue"
      @input="$emit('update:modelValue', !modelValue)"
    >
    <CarvisSpinner
      v-if="loading"
      class="h-2 absolute opacity-30 -mt-[0.8rem]"
    />
    <slot name="label">
      <label
        class="cursor-pointer"
        :for="id"
        @click.prevent="$emit('update:modelValue', !modelValue)"
      >
        <slot />
      </label>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  disabled?: boolean
  loading?: boolean
  id: string
  modelValue: boolean
}>()

const checked = computed(() => props.loading ? undefined : props.modelValue)
defineEmits(['update:modelValue'])
</script>
